module.exports = "<div class=\"gw-controls-radios\">\n    <div class=\"gw-controls-radios-repeat-wrapper\">\n        <div class=\"gw-controls-radios-repeat\" ng-repeat=\"item in model.aspects.availableValues track by item.code\">\n            <input\n                    type=\"radio\"\n                    id=\"{{ctrlId}}{{$index}}\"\n                    ng-value=\"item\"\n                    ng-model=\"model.value\"\n            />\n            <label for=\"{{ctrlId}}{{$index}}\">\n                {{item.name}}\n            </label>\n        </div>\n    </div>\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/quoteandbind/ho/directives/templates/ho-typelist-radios.html
 ** module id = 758
 ** module chunks = 0
 **/